.container {
    width: 100%;
    padding: 1rem;
    background-color: var(--static-background-standard);
    border-radius: 12px;
    height: 100%;
}

.loadingContainer {
    padding: 1rem;
    width: 100%;
    background-color: var(--static-background-standard);
    border-radius: 12px;
    height: 100%;
}
.header {
    display: flex;
    margin-bottom: 2rem;
    gap: 4rem;
}

.statsContainer {
    flex: 1;
}

.titleContainer {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
}

.dot {
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 9999px;
}

.dotSales {
    background-color: #f97316;
}

.dotRefunds {
    background-color: #334155;
}

.label {
    font-size: 0.875rem;
    font-weight: 500;
}

.value {
    font-size: 2rem;
    line-height: 40px;
    font-weight: 500;
    color: var(--static-text-strong)
}

.change {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
    color: #16a34a;
}

.changeText {
    color: #6B7280;
    margin-left: 0.25rem;
}

.chartContainer {
    height: 300px;
    width: 100%;
    position: relative;
}

.dotPrimary {
    background-color: var(--color-primary);
}

.dotSecondary {
    background-color: var(--static-background-inverse-standard);
}

.rightButton {
    position: absolute;
    right: -10px;
    bottom: 2px;
}

.leftButton {
    position: absolute;
    bottom: 1px;
}

.chartWrapper {
    position: relative;
}